const toIcsDate = (date) => new Date(date).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';

export const buildGoogleCalendarUrl = ({ title, description, start, end }) => {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title,
    dates: `${toIcsDate(start)}/${toIcsDate(end)}`,
    details: description || '',
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const buildOutlookCalendarUrl = ({ title, description, start, end }) => {
  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: title,
    startdt: new Date(start).toISOString(),
    enddt: new Date(end).toISOString(),
    body: description || '',
  });
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
};

const escapeIcsText = (text = '') => text.replace(/([,;])/g, '\\$1').replace(/\n/g, '\\n');

export const downloadIcsFile = ({ title, description, start, end }) => {
  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Podsy//Practice Reminder//EN',
    'BEGIN:VEVENT',
    `UID:${Date.now()}@podsy`,
    `DTSTAMP:${toIcsDate(new Date())}`,
    `DTSTART:${toIcsDate(start)}`,
    `DTEND:${toIcsDate(end)}`,
    `SUMMARY:${escapeIcsText(title)}`,
    `DESCRIPTION:${escapeIcsText(description)}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');

  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${title.replace(/[^a-z0-9]/gi, '_') || 'practice'}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
